import '../../resources/css/button.css';
import { Link } from "react-router-dom";

export default function Button({ href, type, children, eventHandler }) {

    let className = '';
    switch (type) {
        case 'info': className = 'btn-info'; break;
        case 'pure': className = 'btn-pure'; break;
        default: className = 'btn-info'; break;
    }

    const finalClassName = 'btn ' + className;

    return (
        <div>
            {href &&
                <Link to={href}>
                    <span className={finalClassName}>
                        {children}
                    </span>
                </Link>
            }

            {eventHandler &&
                <span className={finalClassName} onClick={eventHandler}>
                    {children}
                </span>
            }

        </div>
    );
}